<message-modal #messageBox> &nbsp; </message-modal>
<block-ui #blockUIBox> &nbsp; </block-ui>
<tanzeel-notification-comp ></tanzeel-notification-comp>
<uikit-modal-dialog #uikitmodalDialog></uikit-modal-dialog>
<div class="btn-float-container" *ngIf="floatHelpButtonVisible==true">
	<a class="ui_btn ui_btn_primary float-help-button" href="javascript:void(0)" (click)="showhelpContactView()">Request a Phone call?</a>
</div>

<div>
	<router-outlet></router-outlet>
</div>
